/*
 * GO Belleza — Motor de filtros del tema (modo sin app)
 *
 * Construye los grupos de filtro leyendo los atributos data-gbf-* que cada
 * tarjeta de producto imprime, y filtra al instante en el navegador.
 * Sin dependencias.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 991;

  var CHEVRON = '<svg class="gb-filter__chev" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5l5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SEARCH_ICON = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="5.2" stroke="currentColor" stroke-width="1.5"/><path d="m11 11 3.4 3.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var CROSS = '<svg viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="m1 1 8 8M9 1 1 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function normalize(value) {
    var text = (value === null || value === undefined ? '' : String(value)).toLowerCase();
    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '');
    }
    return text;
  }

  ready(function () {
    var root = document.querySelector('[data-gb-filters][data-gb-local]');
    if (!root) return;

    var configEl = document.querySelector('[data-gb-config]');
    var config = { groups: [], showCount: true, openDefault: true, priceSlider: true, searchThreshold: 10, currency: '$', total: 0 };
    if (configEl) {
      try { config = Object.assign(config, JSON.parse(configEl.textContent)); } catch (error) { /* usa valores por defecto */ }
    }

    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-gbf-card]'));
    var groupsHost = root.querySelector('[data-gb-groups]');
    if (!cards.length || !groupsHost) return;

    var grid = cards[0].parentNode;
    var locale = document.documentElement.lang || 'es';

    /* ---------------- lectura de datos de cada tarjeta ---------------- */
    function valuesOf(card, key) {
      if (key === 'precio') return [];
      if (key === 'disponible') {
        return [card.getAttribute('data-gbf-disponible') === '1' ? 'En existencia' : 'Agotado'];
      }
      var raw = card.getAttribute('data-gbf-' + key) || '';
      if (key === 'marca' || key === 'tipo') {
        raw = raw.trim();
        return raw ? [raw] : [];
      }
      var out = [];
      raw.split('|').forEach(function (piece) {
        var value = piece.trim();
        if (value && out.indexOf(value) === -1) out.push(value);
      });
      return out;
    }

    function priceOf(card) {
      var value = parseFloat(card.getAttribute('data-gbf-precio'));
      return isNaN(value) ? 0 : value;
    }

    function money(amount) {
      var number = parseFloat(amount);
      if (isNaN(number)) number = 0;
      try { return config.currency + number.toLocaleString(locale, { maximumFractionDigits: 0 }); }
      catch (error) { return config.currency + Math.round(number); }
    }

    /* ---------------- construcción de los grupos ---------------- */
    var priceMin = Infinity;
    var priceMax = 0;
    cards.forEach(function (card) {
      var price = priceOf(card);
      if (price < priceMin) priceMin = price;
      if (price > priceMax) priceMax = price;
    });
    if (priceMin === Infinity) priceMin = 0;
    priceMin = Math.floor(priceMin);
    priceMax = Math.ceil(priceMax);

    var groups = [];
    (config.groups || []).forEach(function (definition) {
      if (definition.kind === 'price') {
        if (priceMax > priceMin) groups.push({ key: 'precio', label: definition.label, kind: 'price' });
        return;
      }
      var values = [];
      cards.forEach(function (card) {
        valuesOf(card, definition.key).forEach(function (value) {
          if (values.indexOf(value) === -1) values.push(value);
        });
      });
      if (values.length < 2) return;

      if (definition.sort === 'numeric') {
        values.sort(function (a, b) {
          var na = parseFloat(a);
          var nb = parseFloat(b);
          var aNum = !isNaN(na);
          var bNum = !isNaN(nb);
          if (aNum && bNum && na !== nb) return na - nb;
          if (aNum && !bNum) return -1;
          if (!aNum && bNum) return 1;
          return String(a).localeCompare(String(b), 'es', { numeric: true });
        });
      } else if (definition.key === 'disponible') {
        values.sort();
      } else {
        values.sort(function (a, b) {
          return String(a).localeCompare(String(b), 'es', { numeric: true, sensitivity: 'base' });
        });
      }

      groups.push({
        key: definition.key,
        label: definition.label,
        kind: 'list',
        values: values
      });
    });

    if (!groups.length) return;

    /* ---------------- render ---------------- */
    var priceStep = priceMax > 5000 ? 100 : (priceMax > 1000 ? 25 : (priceMax > 200 ? 5 : 1));

    function renderList(group) {
      var items = group.values.map(function (value, index) {
        var id = 'gbf-' + group.key + '-' + index;
        return '<li class="gb-opt" data-gb-value="' + esc(value) + '">'
          + '<input class="gb-opt__input" type="checkbox" id="' + id + '" value="' + esc(value) + '" data-gb-filter="' + esc(group.key) + '">'
          + '<label class="gb-opt__label" for="' + id + '"><span class="gb-opt__box"></span>'
          + '<span class="gb-opt__text">' + esc(value) + '</span>'
          + (config.showCount ? '<span class="gb-opt__count" data-gb-count>0</span>' : '')
          + '</label></li>';
      }).join('');

      var search = group.values.length > config.searchThreshold
        ? '<div class="gb-filter__search">' + SEARCH_ICON
          + '<input type="search" placeholder="Buscar en ' + esc(String(group.label).toLowerCase()) + '" aria-label="Buscar en ' + esc(group.label) + '" data-gb-search>'
          + '</div>'
        : '';

      return '<details class="gb-filter" data-gb-group="' + esc(group.key) + '"'
        + (config.openDefault ? ' open' : '') + '>'
        + '<summary class="gb-filter__summary"><span class="gb-filter__label">' + esc(group.label) + '</span>'
        + '<span class="gb-filter__badge" data-gb-badge hidden>0</span>' + CHEVRON + '</summary>'
        + '<div class="gb-filter__body">' + search
        + '<ul class="gb-filter__list">' + items + '</ul>'
        + '<p class="gb-filters__empty" data-gb-no-results style="display:none;">Sin coincidencias</p>'
        + '</div></details>';
    }

    function renderPrice(group) {
      var slider = config.priceSlider
        ? '<div class="gb-price__slider">'
          + '<input class="gb-range" type="range" min="' + priceMin + '" max="' + priceMax + '" step="' + priceStep + '" value="' + priceMax + '" aria-label="Precio máximo" data-gb-slider>'
          + '<div class="gb-price__legend"><span>Precio máximo</span><strong data-gb-price-output>' + money(priceMax) + '</strong></div>'
          + '</div>'
        : '';

      return '<details class="gb-filter gb-filter--price" data-gb-group="precio" open>'
        + '<summary class="gb-filter__summary"><span class="gb-filter__label">' + esc(group.label) + '</span>'
        + '<span class="gb-filter__badge" data-gb-badge hidden>1</span>' + CHEVRON + '</summary>'
        + '<div class="gb-filter__body"><div class="gb-price" data-gb-price>'
        + '<div class="gb-price__inputs">'
        + '<span class="gb-price__field"><span class="gb-price__cur">' + esc(config.currency) + '</span>'
        + '<input class="gb-price__input" type="number" inputmode="numeric" placeholder="' + priceMin + '" min="' + priceMin + '" max="' + priceMax + '" aria-label="Precio mínimo" data-gb-price-min></span>'
        + '<span class="gb-price__sep">—</span>'
        + '<span class="gb-price__field"><span class="gb-price__cur">' + esc(config.currency) + '</span>'
        + '<input class="gb-price__input" type="number" inputmode="numeric" placeholder="' + priceMax + '" min="' + priceMin + '" max="' + priceMax + '" aria-label="Precio máximo" data-gb-price-max></span>'
        + '</div>' + slider
        + '<button type="button" class="gb-btn gb-btn--primary" data-gb-price-apply>Aplicar precio</button>'
        + '</div></div></details>';
    }

    groupsHost.innerHTML = groups.map(function (group) {
      return group.kind === 'price' ? renderPrice(group) : renderList(group);
    }).join('');

    /* ---------------- estado y filtrado ---------------- */
    var chipsHost = root.querySelector('[data-gb-chips]');
    var clearButton = root.querySelector('[data-gb-clear]');
    var activeCounters = root.querySelectorAll('[data-gb-active-count]');
    var visibleCounter = root.querySelector('[data-gb-visible-count]');
    var slider = root.querySelector('[data-gb-slider]');
    var minInput = root.querySelector('[data-gb-price-min]');
    var maxInput = root.querySelector('[data-gb-price-max]');
    var priceOutput = root.querySelector('[data-gb-price-output]');
    var priceBadge = root.querySelector('[data-gb-group="precio"] [data-gb-badge]');
    var totalLabel = document.querySelector('.total-products');
    var totalLabelOriginal = totalLabel ? totalLabel.textContent : '';

    var emptyState = document.createElement('div');
    emptyState.className = 'gb-no-products col-12';
    emptyState.innerHTML = '<p>No hay productos que coincidan con los filtros seleccionados.</p>'
      + '<button type="button" class="gb-btn gb-btn--primary" data-gb-clear>Quitar filtros</button>';
    emptyState.hidden = true;
    if (grid) grid.appendChild(emptyState);

    function selections() {
      var selected = {};
      Array.prototype.forEach.call(root.querySelectorAll('[data-gb-filter]'), function (input) {
        if (!input.checked) return;
        var key = input.getAttribute('data-gb-filter');
        if (!selected[key]) selected[key] = [];
        selected[key].push(input.value);
      });
      return selected;
    }

    function priceRange() {
      var min = minInput && minInput.value !== '' ? parseFloat(minInput.value) : null;
      var max = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : null;
      if (min !== null && isNaN(min)) min = null;
      if (max !== null && isNaN(max)) max = null;
      return { min: min, max: max };
    }

    function matches(card, selected, range, skipKey) {
      for (var key in selected) {
        if (!Object.prototype.hasOwnProperty.call(selected, key)) continue;
        if (key === skipKey) continue;
        var values = valuesOf(card, key);
        var hit = false;
        for (var i = 0; i < selected[key].length; i++) {
          if (values.indexOf(selected[key][i]) !== -1) { hit = true; break; }
        }
        if (!hit) return false;
      }
      if (skipKey !== 'precio' && range) {
        var price = priceOf(card);
        if (range.min !== null && price < range.min) return false;
        if (range.max !== null && price > range.max) return false;
      }
      return true;
    }

    function apply() {
      var selected = selections();
      var range = priceRange();
      var visible = 0;

      cards.forEach(function (card) {
        var ok = matches(card, selected, range, null);
        card.style.display = ok ? '' : 'none';
        if (ok) visible++;
      });

      // recuento por opción, ignorando el propio grupo
      groups.forEach(function (group) {
        if (group.kind === 'price') return;
        var groupEl = root.querySelector('[data-gb-group="' + group.key + '"]');
        if (!groupEl) return;

        Array.prototype.forEach.call(groupEl.querySelectorAll('.gb-opt'), function (item) {
          var input = item.querySelector('.gb-opt__input');
          var value = input.value;
          var count = 0;
          cards.forEach(function (card) {
            if (valuesOf(card, group.key).indexOf(value) === -1) return;
            if (matches(card, selected, range, group.key)) count++;
          });
          var counter = item.querySelector('[data-gb-count]');
          if (counter) counter.textContent = count;
          var disabled = count === 0 && !input.checked;
          item.classList.toggle('gb-opt--disabled', disabled);
          input.disabled = disabled;
        });

        var badge = groupEl.querySelector('[data-gb-badge]');
        var chosen = selected[group.key] ? selected[group.key].length : 0;
        if (badge) {
          badge.textContent = chosen;
          badge.hidden = chosen === 0;
        }
      });

      var priceActive = range.min !== null || range.max !== null;
      if (priceBadge) priceBadge.hidden = !priceActive;

      var activeTotal = 0;
      for (var key in selected) {
        if (Object.prototype.hasOwnProperty.call(selected, key)) activeTotal += selected[key].length;
      }
      if (priceActive) activeTotal++;

      Array.prototype.forEach.call(activeCounters, function (element) {
        element.textContent = activeTotal;
        element.hidden = activeTotal === 0;
      });
      if (clearButton) clearButton.hidden = activeTotal === 0;
      if (visibleCounter) visibleCounter.textContent = visible;

      renderChips(selected, range);

      emptyState.hidden = visible !== 0;

      if (totalLabel) {
        totalLabel.textContent = activeTotal > 0
          ? 'Mostrando ' + visible + ' de ' + cards.length + ' resultados'
          : totalLabelOriginal;
      }
    }

    function renderChips(selected, range) {
      if (!chipsHost) return;
      var chips = [];
      for (var key in selected) {
        if (!Object.prototype.hasOwnProperty.call(selected, key)) continue;
        selected[key].forEach(function (value) {
          chips.push('<button type="button" class="gb-chip" data-gb-remove="' + esc(key) + '" data-gb-remove-value="' + esc(value) + '">'
            + esc(value) + CROSS + '</button>');
        });
      }
      if (range.min !== null || range.max !== null) {
        chips.push('<button type="button" class="gb-chip" data-gb-remove="precio">'
          + money(range.min === null ? priceMin : range.min) + ' — ' + money(range.max === null ? priceMax : range.max)
          + CROSS + '</button>');
      }
      chipsHost.innerHTML = chips.join('');
      chipsHost.hidden = chips.length === 0;
    }

    function clearAll() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-gb-filter]'), function (input) {
        input.checked = false;
      });
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
      if (slider) {
        slider.value = priceMax;
        paintSlider();
      }
      apply();
    }

    function paintSlider() {
      if (!slider) return;
      var value = parseFloat(slider.value);
      if (isNaN(value)) value = priceMax;
      var span = priceMax - priceMin;
      var percent = span > 0 ? ((value - priceMin) / span) * 100 : 100;
      slider.style.setProperty('--gb-fill', Math.max(0, Math.min(100, percent)) + '%');
      if (priceOutput) priceOutput.textContent = money(value);
    }

    /* ---------------- eventos ---------------- */
    root.addEventListener('change', function (event) {
      if (event.target.hasAttribute && event.target.hasAttribute('data-gb-filter')) apply();
    });

    root.addEventListener('click', function (event) {
      var remove = event.target.closest ? event.target.closest('[data-gb-remove]') : null;
      if (remove) {
        var key = remove.getAttribute('data-gb-remove');
        var value = remove.getAttribute('data-gb-remove-value');
        if (key === 'precio') {
          if (minInput) minInput.value = '';
          if (maxInput) maxInput.value = '';
          if (slider) { slider.value = priceMax; paintSlider(); }
        } else {
          Array.prototype.forEach.call(root.querySelectorAll('[data-gb-filter="' + key + '"]'), function (input) {
            if (input.value === value) input.checked = false;
          });
        }
        apply();
        return;
      }
      if (event.target.closest && event.target.closest('[data-gb-clear]')) clearAll();
      if (event.target.closest && event.target.closest('[data-gb-price-apply]')) apply();
    });

    document.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-gb-clear]') : null;
      if (target && !root.contains(target)) clearAll();
    });

    if (slider) {
      paintSlider();
      slider.addEventListener('input', function () {
        if (maxInput) maxInput.value = slider.value;
        paintSlider();
      });
      slider.addEventListener('change', apply);
    }

    if (maxInput) {
      maxInput.addEventListener('input', function () {
        if (slider) {
          slider.value = maxInput.value === '' ? priceMax : maxInput.value;
          paintSlider();
        }
      });
      maxInput.addEventListener('change', apply);
    }
    if (minInput) minInput.addEventListener('change', apply);

    Array.prototype.forEach.call(root.querySelectorAll('[data-gb-search]'), function (input) {
      input.addEventListener('input', function () {
        var group = input.closest('[data-gb-group]');
        if (!group) return;
        var term = normalize(input.value).trim();
        var visible = 0;
        Array.prototype.forEach.call(group.querySelectorAll('.gb-opt'), function (item) {
          var haystack = normalize(item.getAttribute('data-gb-value'));
          var match = term === '' || haystack.indexOf(term) !== -1;
          item.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });
        var empty = group.querySelector('[data-gb-no-results]');
        if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
      });
    });

    /* ---------------- cajón lateral en móvil ---------------- */
    var toggle = root.querySelector('[data-gb-toggle]');
    if (toggle) {
      var host = document.querySelector('.grid-nav-wraper') || document.querySelector('.tab-content');
      var holder = document.createElement('div');
      holder.className = 'gb-toggle-wrap';
      if (host && host.parentNode) {
        host.parentNode.insertBefore(holder, host);
        holder.appendChild(toggle);
        toggle.classList.add('is-ready');
        root.classList.add('gb-filters--drawer');
      }

      var backdrop = document.createElement('div');
      backdrop.className = 'gb-backdrop';
      document.body.appendChild(backdrop);

      var isOpen = false;
      var setOpen = function (open) {
        isOpen = open;
        root.classList.toggle('is-open', open);
        backdrop.classList.toggle('is-open', open);
        document.body.classList.toggle('gb-no-scroll', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      toggle.addEventListener('click', function () { setOpen(!isOpen); });
      backdrop.addEventListener('click', function () { setOpen(false); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-gb-close]'), function (button) {
        button.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen) setOpen(false);
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth > MOBILE_MAX && isOpen) setOpen(false);
      });
    }

    apply();
  });
})();
